import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import moment from "moment";
import "./timelineChart.scss";

const TimelineChart = ({ data, unit }) => {
    if (!data || data.length === 0) return (
        <span>Keine Daten</span>
    );

    const toLocalMoment = (ts) => moment.parseZone(ts).format("HH:mm");

    return (
        <div className="timelineChart">
            <ResponsiveContainer width="100%" height={200}>
                <LineChart data={data}>
                    <XAxis
                        dataKey="timestamp"
                        tickFormatter={toLocalMoment}
                        interval="equidistantPreserveEnd"
                        hide={false}
                    />
                    <YAxis hide={true} />

                    <Tooltip
                        labelFormatter={(ts) => toLocalMoment(ts) + " Uhr"}
                        formatter={(v) => [`${v} ${unit}`, "Füllstand"]}
                    />

                    <Line
                        type="monotone"
                        dataKey="fuelLevel"
                        stroke="#cd071e"
                        strokeWidth={3}
                        dot={false}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default TimelineChart;